/**
 * gpo-telemetry.js
 * GPOの読み込み状況をGA4へ計測 ＋ 立ち上がり前のカート追加をガード。
 * 経緯・実測値: claude/GPO必須オプション_サーバー未検証_抜け穴実証_580054.md §13-14, §20
 */
(function () {
  'use strict';

  if (!window.location.pathname.startsWith('/products/')) return;

  var CART_FORM_SEL = 'form[action*="/cart/add"]';
  var ATC_BTN_SEL   = 'button[name="add"], button[type="submit"], input[type="submit"]';

  var POLL_MS            = 100;
  var TIMEOUT_MS         = 20000;
  var GTAG_WAIT_MS       = 8000;
  var HANDOFF_TIMEOUT_MS = 8000;
  var CLONE_WAIT_MS      = 150;

  // ---- GPO判定 --------------------------------------------------------------
  // DOM（.gpo-container等）では「オプション無し商品」と区別できないためグローバルで見る
  function gpoReady() {
    return !!(window.GPOConfigs || window.Globo);
  }

  // present: タグはあるのに実行されない / absent: App Extension未挿入
  function scriptTagState() {
    var el = document.querySelector('script[src*="gpomain"], script[src*="globo-product-options"]');
    return el ? 'present' : 'absent';
  }

  function productHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '(unknown)';
  }

  function bucket(ms) {
    if (ms === null) return 'z_never';
    if (ms < 500)   return 'a_0-500';
    if (ms < 1500)  return 'b_500-1500';
    if (ms < 3000)  return 'c_1500-3000';
    if (ms < 8000)  return 'd_3000-8000';
    return 'e_8000+';
  }

  function cartForms() {
    return [].slice.call(document.querySelectorAll(CART_FORM_SEL));
  }

  function variantIdOf(form) {
    var el = form && form.querySelector('[name="id"]');
    return el ? String(el.value) : '(unknown)';
  }

  // Speculation Rules（theme.liquid）のヒット率計測用。値は各3種に固定
  function navInfo() {
    var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    var d = (nav && nav.deliveryType) || '';
    var from = 'direct';
    try {
      if (document.referrer) {
        from = new URL(document.referrer).origin === location.origin ? 'internal' : 'external';
      }
    } catch (e) { /* noop */ }
    return {
      nav_delivery: d === 'navigational-prefetch' ? 'prefetch' : (d === 'cache' ? 'cache' : 'network'),
      nav_from:     from
    };
  }

  // ---- GA4送信 --------------------------------------------------------------
  function send(name, params) {
    var waited = 0;
    (function attempt() {
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', name, params);
          return;
        }
      } catch (e) {
        return;
      }
      waited += 250;
      if (waited <= GTAG_WAIT_MS) setTimeout(attempt, 250);
    })();
  }

  // ---- gpo_load_status（1PVにつき1回） --------------------------------------
  var statusReported = false;

  function reportStatus(result, ms) {
    if (statusReported) return;
    statusReported = true;
    var n = navInfo();
    send('gpo_load_status', {
      gpo_result:     result,
      gpo_bucket:     bucket(ms),
      gpo_ms:         ms === null ? -1 : Math.round(ms),
      gpo_product:    productHandle(),
      gpo_script_tag: scriptTagState(),
      nav_delivery:   n.nav_delivery,
      nav_from:       n.nav_from
    });
  }

  var statusTimer = setInterval(function () {
    if (gpoReady()) {
      clearInterval(statusTimer);
      reportStatus('ready', performance.now());
      return;
    }
    if (performance.now() >= TIMEOUT_MS) {
      clearInterval(statusTimer);
      reportStatus('never_ready', null);
    }
  }, POLL_MS);

  // 離脱時フラッシュ。これが無いと「壊れていて早々に離脱した人」を取りこぼす
  window.addEventListener('pagehide', function () {
    if (!statusReported && !gpoReady()) reportStatus('never_ready', null);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden' && !statusReported && !gpoReady()) {
      reportStatus('never_ready', null);
    }
  });

  // ---- ガード ---------------------------------------------------------------
  var bypassReported = false;
  var waiting        = false;
  var handedOff      = false;

  function reportBypass(form) {
    if (bypassReported) return;
    bypassReported = true;
    send('gpo_bypass_submit', {
      gpo_product:    productHandle(),
      gpo_variant:    variantIdOf(form),
      gpo_ms:         Math.round(performance.now()),
      gpo_script_tag: scriptTagState()
    });
  }

  // form.submit() はsubmitイベントを発火せずテーマのAJAX処理を素通りするので使わない
  function release(form) {
    waiting = false;
    handedOff = true;
    try {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        var btn = form.querySelector(ATC_BTN_SEL);
        if (btn) btn.click();
      }
    } catch (e) {
      /* noop */
    }
    setTimeout(function () { handedOff = false; }, 2000);
  }

  // クローンは常に在るとは限らない（必須充足時にGPOが消して素のボタンに戻す）。
  // 無い場合はproperties[...]が注入済みなので、そのまま送信すれば正しい行になる
  function handoff(form) {
    waiting = false;
    var clone = form.querySelector('.gpo-clone-atc-button') ||
                document.querySelector('.gpo-clone-atc-button');
    if (clone) {
      try { clone.click(); return; } catch (e) { /* fallthrough */ }
    }
    release(form);
  }

  function waitThenHandoff(form) {
    var t0 = performance.now();
    var iv = setInterval(function () {
      if (gpoReady()) {
        clearInterval(iv);
        setTimeout(function () { handoff(form); }, CLONE_WAIT_MS);
        return;
      }
      if (performance.now() - t0 >= HANDOFF_TIMEOUT_MS) {
        clearInterval(iv);
        send('gpo_handoff_timeout', {
          gpo_product:    productHandle(),
          gpo_variant:    variantIdOf(form),
          gpo_ms:         Math.round(performance.now()),
          gpo_script_tag: scriptTagState()
        });
        release(form);   // 詰ませない。従来どおりの挙動に戻す
      }
    }, POLL_MS);
  }

  function formOf(btn) {
    var f = btn.closest(CART_FORM_SEL);
    if (f) return f;
    if (btn.form && /\/cart\/add/.test(btn.form.getAttribute('action') || '')) return btn.form;
    return null;
  }

  function hold(form) {
    if (waiting) return;
    waiting = true;
    waitThenHandoff(form);
  }

  // 主ガード。テーマはclickを捕まえて自前でfetch('/cart/add.js')を撃つため、
  // submitを塞いでもカート追加は止まらない（実測済み）。必ずclickで止めること。
  // stopImmediatePropagationにはしない（product-page-fix.jsのスピナー制御を生かす）
  document.addEventListener('click', function (e) {
    if (handedOff || gpoReady()) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(ATC_BTN_SEL);
    if (!btn) return;
    var form = formOf(btn);
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();
    reportBypass(form);
    hold(form);
  }, true);

  // 副ガード（保険）
  function guardForm(form) {
    if (form._a97GpoGuarded) return;
    form._a97GpoGuarded = true;

    form.addEventListener('submit', function (e) {
      if (handedOff || gpoReady()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      reportBypass(form);
      hold(form);
    }, true);
  }

  function guardAll() {
    cartForms().forEach(guardForm);
  }

  // ---- 起動 -----------------------------------------------------------------
  function boot() {
    guardAll();
    var obs = new MutationObserver(guardAll);
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, TIMEOUT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();